import { useEffect } from 'react'

export const DisableHtmlTagScroll = () => {
  useEffect(() => {
    const OVERFLOW_HIDDEN = 'mc-overflow--hidden'
    const html = document.getElementsByTagName('html')[0]
    html.classList.add(OVERFLOW_HIDDEN)
    return () => {
      html.classList.remove(OVERFLOW_HIDDEN)
    }
  })

  return null
}
